import { render, staticRenderFns } from "./HealthProfessionalList.vue?vue&type=template&id=e64b7b86&scoped=true&"
import script from "./HealthProfessionalList.vue?vue&type=script&lang=ts&"
export * from "./HealthProfessionalList.vue?vue&type=script&lang=ts&"
import style0 from "./HealthProfessionalList.vue?vue&type=style&index=0&id=e64b7b86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64b7b86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VContainer,VIcon})
